import { render } from "./Index_concept.vue?vue&type=template&id=c0b85242&scoped=true"
import script from "./Index_concept.vue?vue&type=script&lang=js"
export * from "./Index_concept.vue?vue&type=script&lang=js"

import "./Index_concept.vue?vue&type=style&index=0&id=c0b85242&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-c0b85242"

export default script